import {
  CANVAS,
  GCLASSROOM,
  GDOCS,
  GDRIVE,
  GFORMS,
  GMAIL,
  GSHEETS,
  GSLIDES
} from '@mote/helpers/constants'
import { normalizeURL } from './normalizeURL'

export const getApplicationKey = (url?: string) => {
  url = normalizeURL(url)

  if (url.includes('instructure.com/')) {
    return CANVAS
  }

  if (!url.includes('google.com/')) {
    return ''
  }
  if (
    url.includes('/static/') ||
    url.includes('/iframeapi') ||
    url.includes('/bscframe')
  ) {
    return ''
  }
  if (url.includes('https://docs.google.com/document/')) {
    return GDOCS
  } else if (url.includes('https://docs.google.com/presentation/')) {
    return GSLIDES
  } else if (
    url.includes('https://drive.google.com/') ||
    url.includes('https://docs.google.com/file/')
  ) {
    return GDRIVE
  } else if (url.includes('https://docs.google.com/spreadsheets/')) {
    return GSHEETS
  } else if (url.includes('https://docs.google.com/forms/')) {
    return GFORMS
  } else if (url.includes('https://classroom.google.com/')) {
    return GCLASSROOM
  } else if (url.includes('https://mail.google.com/')) {
    return GMAIL
  } else {
    return ''
  }
}
